import styled from 'styled-components';

export const MachineToMachineStyled = styled.div``;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/MachineToMachine/styled.js